import { render } from "./createTemplateProposalComponent.vue?vue&type=template&id=22298740&scoped=true"
import script from "./createTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./createTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./createTemplateProposalComponent.vue?vue&type=style&index=0&id=22298740&lang=css"
import "./createTemplateProposalComponent.vue?vue&type=style&index=1&id=22298740&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22298740"]])

export default __exports__